var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowierzchnieszklaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.66 58.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0v58.66h58.66V0H0ZM1.88,1.88h54.91v54.91H1.88V1.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.13,
    y: 28.23,
    width: 42.4,
    height: 1.88,
    transform: "translate(-12.33 28.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.9,
    y: 21.74,
    width: 27.89,
    height: 1.88,
    transform: "translate(-9.64 22.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.77,
    y: 15.76,
    width: 12.19,
    height: 1.88,
    transform: "translate(-7.16 16.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.64,37.21c-1.17-.35-2.09-.68-2.82-1.02-1.1-.53-1.74-1.07-2.32-1.9-.57-.83-1.05-2.02-1.57-3.78l-.9-3.01-.9,3.01c-.35,1.17-.68,2.09-1.02,2.82-.53,1.1-1.07,1.74-1.9,2.32-.83.57-2.02,1.05-3.78,1.57l-3.01.9,3.01.9c1.17.35,2.09.68,2.82,1.02,1.1.53,1.74,1.07,2.32,1.9.57.83,1.05,2.02,1.57,3.78l.9,3.01.9-3.01c.35-1.17.68-2.09,1.02-2.82.53-1.1,1.07-1.74,1.9-2.32.83-.57,2.02-1.05,3.78-1.57l3.01-.9-3.01-.9ZM39.95,40.88c-.35.51-.64,1.09-.91,1.73-.08-.18-.15-.35-.23-.52-.62-1.3-1.42-2.31-2.54-3.06-.51-.35-1.09-.64-1.73-.91.18-.08.35-.15.52-.23,1.3-.62,2.31-1.42,3.06-2.54.35-.51.64-1.09.91-1.73.08.18.15.35.23.52.62,1.3,1.42,2.31,2.54,3.06.51.35,1.09.64,1.73.91-.18.08-.35.15-.52.23-1.3.62-2.31,1.42-3.06,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.68,4.68v49.3h49.3V4.68H4.68ZM6.56,6.56h45.54v45.54H6.56V6.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowierzchnieszklaneIcon);
export default __webpack_public_path__ + "static/media/Powierzchnie szklane_icon.d9f4a643a01c6978d962cdb52e4d30b4.svg";
export { ForwardRef as ReactComponent };